import { Observable } from "rxjs";
import {
  BoardDesignationFilter,
  ClosingDetail,
  RonMonitorBoard,
} from "./ron-monitor.models";

export abstract class RonMonitorDataSource {
  abstract getBoard(
    date: Date,
    designation: BoardDesignationFilter
  ): Observable<RonMonitorBoard>;

  abstract getDetail(packageId: number): Observable<ClosingDetail>;
}
